import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';
import Link from '@nubank/nuds-web/components/Link/Link';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import Section from 'components/structure/Section';
import Block from 'components/structure/Block/Block';
import { paddingBuilder } from 'styles/themeUtils';

import { StyledImageBlock } from './styles/ImageBlock';

function SectionRewards({ index }) {
  const { formatMessage } = useContext(NuDsContext);

  return (
    <Section backgroundColor="white.default">
      <Block
        blockWidth="50%"
        padding={{
          desktop: paddingBuilder.right(0),
        }}
      >
        <Link
          href={formatMessage({ id: `cms.homePage.homeCardsArea.${index}.cardPreTitleLink` })}
          typographyProps={{
            variant: 'title',
            color: 'primary',
            colorVariant: 'default',
          }}
          intlKey={`cms.homePage.homeCardsArea.${index}.cardPreTitleText`}
        />
        <Typography
          variant="title"
          tag="h2"
          color="black"
          colorVariant="default"
          gutterBottom={2}
          intlKey={`cms.homePage.homeCardsArea.${index}.cardTitle`}
          whiteSpace="pre-line"
        />

        <Link
          href={formatMessage({ id: `cms.homePage.homeCardsArea.${index}.cardCtaLink` })}
          variant="action"
          color="primary"
          intlKey={`cms.homePage.homeCardsArea.${index}.cardCtaText`}
        />
      </Block>

      <FormattedMessage id="REWARDS.HERO.IMAGE_ALT">
        {([alt]) => (
          <StyledImageBlock
            blockWidth="50%"
            backgroundImage="rewards-home-card/rewards-home-card.png"
            alt={alt}
            loading="lazy"
            padding={{
              default: paddingBuilder.all(0),
              tablet: paddingBuilder.all(0, 2, 4, 2),
              desktop: paddingBuilder.all(4),
            }}
          />
        )}
      </FormattedMessage>
    </Section>
  );
}

SectionRewards.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(SectionRewards);
